const opsiStatus = [
  { id: "Draft", label: "Draft" },
  { id: "On Progress", label: "On Progress" },
  { id: "Open", label: "Open" },
  { id: "TT", label: "TT" },
  { id: "TT Transfer", label: "TT Transfer" },
  { id: "Transfer", label: "Transfer" },
  { id: "Giro", label: "Giro" },
  { id: "TT Nagih", label: "TT Nagih" },
  { id: "Belum Tertagih", label: "Belum Tertagih" },
  { id: "Tidak Bayar", label: "Tidak Bayar" },
  { id: "Bayar", label: "Bayar Lunas" },
  { id: "Sebagian", label: "Bayar Sebagian" },
  { id: "Closed", label: "Closed" },
];

export default opsiStatus;
